/**
 * Visit Clinic Invoice API service (来院用領収書(窓口))
 * List data is fetched via Continuation API.
 * This service handles PDF print only.
 */

import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import type { VisitClinicInvoicePrintPayload } from './types';

/**
 * Print visit clinic invoice PDF (領収書 / 保険外明細 / 月別 / format).
 * Returns a Blob that can be opened in a new browser tab.
 */
export async function printVisitClinicInvoice(
  siteType: string,
  clinicNumber: string,
  payload: VisitClinicInvoicePrintPayload
): Promise<Blob> {
  const path = clinicApiPath(siteType, clinicNumber, '/visit-clinic-invoices/print');
  const res = await apiClient.post(path, payload, {
    responseType: 'blob',
  });
  return res.data as Blob;
}
